// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a3J-p","background-$(backgroundColor)":"b3J-p","external":"c3J-p","form":"d3J-p","fullWidth":"e3J-p","container":"f3J-p"};